/* eslint-disable import/order */
import { advancedRoadmapsPlanPageInitialChecksResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { planSetupPageRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/planSetupPageRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import SetupPage, { LazyAdvancedRoadmapsSetup } from './ui/setup/index.tsx';

export const planSetupPageRouteEntry: Route = createEntry(planSetupPageRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: SetupPage,
	layout: globalLayout,
	resources: [...getNavigationResources(), advancedRoadmapsPlanPageInitialChecksResource],
	forPaint: [LazyAtlassianNavigation, LazyAdvancedRoadmapsSetup],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
